// extracted by mini-css-extract-plugin
module.exports = {"google-button":"GoogleButton--google-button--3oLaA","googleButton":"GoogleButton--google-button--3oLaA"};